import type { NodeMock, StatePreset } from "../mock-types";
import { getPlayerTeam } from "../mock-utils";

export const mapBanMock: NodeMock = {
  label: "Map Ban",
  description: "Teams take turns banning maps",
  state: (_players, teamCount) => {
    const mapPool = ["map_1", "map_2", "map_3", "map_4", "map_5"];
    const maxBans = mapPool.length - 1;
    const bansPerTeam = Math.max(1, Math.floor(maxBans / teamCount));
    const totalBans = Math.min(bansPerTeam * teamCount, maxBans);

    // Build bansByTeam with one ban for the first two teams, empty for the rest
    const bansByTeam: Record<number, string[]> = {};
    for (let t = 0; t < teamCount; t++) bansByTeam[t] = [];
    bansByTeam[0] = ["map_3"];
    if (teamCount >= 2) bansByTeam[1] = ["map_5"];
    const bannedMaps = Object.values(bansByTeam).flat();
    return {
      mapPool,
      bannedMaps,
      bansByTeam,
      currentTeam: teamCount >= 3 ? 2 : 0,
      banIndex: bannedMaps.length,
      totalBans,
      mapDetails: {
        map_1: { name: "Dust II", imageUrl: "https://picsum.photos/seed/dust2/640/360" },
        map_2: { name: "Mirage", imageUrl: "https://picsum.photos/seed/mirage/640/360" },
        map_3: { name: "Inferno", imageUrl: "https://picsum.photos/seed/inferno/640/360" },
        map_4: { name: "Ascent", imageUrl: "https://picsum.photos/seed/ascent/640/360" },
        map_5: { name: "Haven", imageUrl: "https://picsum.photos/seed/haven/640/360" },
      },
    };
  },
  config: {
    timeoutSecondsPerBan: 30,
    bansPerTeam: 2,
    banOrder: "alternating",
    labels: {
      title: "Map Ban Phase",
    },
  },
};

export const mapBanPresets: StatePreset[] = [
  {
    label: "Fresh",
    build: ({ defaultState, teamCount }) => {
      const bansByTeam: Record<number, string[]> = {};
      for (let t = 0; t < teamCount; t++) bansByTeam[t] = [];
      return {
        state: { ...defaultState, bannedMaps: [], bansByTeam, currentTeam: 0, banIndex: 0 },
      };
    },
  },
  {
    label: "Your Turn",
    build: ({ players, viewerId, defaultState, teamCount }) => {
      const viewerTeam = getPlayerTeam(players, viewerId, teamCount);
      const bansByTeam: Record<number, string[]> = {};
      for (let t = 0; t < teamCount; t++) bansByTeam[t] = t < viewerTeam ? ["map_5"] : [];
      const bannedMaps = Object.values(bansByTeam).flat();
      return {
        state: {
          ...defaultState,
          bannedMaps,
          bansByTeam,
          currentTeam: viewerTeam,
          banIndex: bannedMaps.length,
        },
      };
    },
  },
  {
    label: "Complete",
    build: ({ defaultState, teamCount }) => {
      const maps = ["map_1", "map_2", "map_3", "map_4", "map_5"];
      const bansByTeam: Record<number, string[]> = {};
      let idx = 0;
      for (let t = 0; t < teamCount; t++) {
        bansByTeam[t] = [];
        for (let b = 0; b < 2 && idx < maps.length - 1; b++) {
          bansByTeam[t].push(maps[idx]!);
          idx++;
        }
      }
      const bannedMaps = Object.values(bansByTeam).flat();
      return {
        state: {
          ...defaultState,
          bannedMaps,
          bansByTeam,
          currentTeam: 0,
          banIndex: bannedMaps.length,
          totalBans: bannedMaps.length,
        },
      };
    },
  },
];
